export default __webpack_public_path__ + "assets/food-delivery.5faca08c.svg";